<template>
  <div>
    <ModalInformes :showModalInformes="showModalInformes" @close="closeModalInformes"
      @handleVisibilidadInformes="handleVisibilidadInformes"></ModalInformes>
    <ModalVisibilidad :showModalVisibilidad="showModalVisibilidad" @close="closeModalVisibilidad"
      @handleVisibilidad="handleVisibilidad"></ModalVisibilidad>
    <MenuAyudaResumen :showModalAyuda="showModalAyuda" @close="closeModalAyuda"></MenuAyudaResumen>

    <ModalMapaFaenas :showModalMapa="showModalMapa" :propIdFaena="this.idFaenaSeleccionada" :seriesFaenas="seriesFaenas"
      @close="closeModal">
    </ModalMapaFaenas>

    <div class="grid xs:grid-cols-2 sm:grid-cols-2 lg:grid-cols-2 gap-0">
      <div class="m-0 pt-2 rounded col-span-2">
        <!--- menu nuevo-->
        <div class="grid xs:grid-cols-1 sm:grid-cols-1 lg:grid-cols-1 gap-1 pb-5">
          <div class="container mx-auto pt-1 pb-0 pl-0 pr-0">

            <div class="  pl-0">


              <div class="w-full lg:w-1/6 px-1 text-center">
                <div class="grid grid-cols-2 ">
                  <a href="#" class="flex flex-col items-center p-3 rounded-lg transition hover:bg-gray-50"
                    @click="loadModalVisibilidad(true)">
                    <div class="flex items-center justify-center h-12 w-12 rounded-md bg-indigo-500 text-white">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="w-8 h-8">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M2.458 12C3.732 7.943 7.522 5 12 5c4.478 0 8.268 2.943 9.542 7-.034.096-.07.192-.106.287C20.268 16.057 16.478 19 12 19c-4.478 0-8.268-2.943-9.542-7-.036-.095-.072-.191-.106-.287z" />
                      </svg>
                    </div>
                    <p class="mt-2 text-xs text-gray-900">{{ $t('visibilidad') }}</p>
                  </a>

                  <a href="#" class="flex flex-col items-center p-3 rounded-lg transition hover:bg-gray-50"
                    @click="loadModalAyuda(true)">
                    <div class="flex items-center justify-center h-12 w-12 rounded-md bg-indigo-500 text-white">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="w-8 h-8">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                      </svg>
                    </div>
                    <p class="mt-2 text-xs text-gray-900">{{ $t('informacion') }}</p>
                  </a>
                </div>
              </div>

            </div>
          </div>
        </div>
        <!--- menu nuevo-->
        <div class="container">
          <div class="w-full text-left ml-4 bg-white ">

            <span class="text-1xl   font-bold text-black ">
              {{ $t('resumen') }}
            </span>

          </div>

        </div>
        <div @dragover="handleDragOVer" @dragenter="handleDragEnter" @drop="handleDrop"
          class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-2 file: bg-gray-200 ml-6">
          <div class="grid grid-cols-1 min-h-full gap-2 ">
            <div v-if="this.$store.getters.getDroppables.length == 0" class="h-64 pt-10">
              <div class="flex items-start mb-4 pb-4">
                <div class="">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="w-12 h-12">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15M12 9l3 3m0 0-3 3m3-3H2.25" />
                  </svg>
                </div>
                <div class="">{{ $t('arrastre') }}</div>
              </div>
            </div>

            <div class="overflow-x-scroll flex items-start mb-4 pb-4 bg-white">

              <div v-for="f in this.$store.getters.getDroppables" :key="f.id"
                class="bg-white w-100 o shadow rounded-br mb-0 mt-3">
                <div v-if="f.visible == 1" class="ml-auto w-357 mx-2 bg-white" style="width: 357px">
 
                  <PanelFaena :draggable="true" @drop="handleDropFaena(f.id)" @dragstart="handleDragFaena(f.id)" :class="{
                    'border-dotted  border-gray-600 border-2': isDragStart,
                    'border-solid border-gray-300 border-2': !isDragStart,
                    'border-solid border-red-300 border-2':
                      f.id == this.$store.getters.getIdCurrentDroppable,
                  }" @dragover="handleDragOver" :f="f" :seriesFaenas="seriesFaenas"
                    @chgHistorialCentros="loadHistorial" @chgFaenaCentros="loadCentros"
                    @sendDivisionesMenuLat="enviaDivisionesMenuLat"></PanelFaena>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="grid xs:grid-cols-1 sm:grid-cols-1 lg:grid-cols-1 pt-3 pr-3 pl-6">
      <div class="lg:flex">
        <div class="lg:w-1/2 pl-5 text-left">
          <h1 class="text-1xl font-extrabold text-left text-cyan-800">
            {{ $t('seleccione_fechas') }}
          </h1>

          <CalendarioFaenas @getFecCalendar="getFecCalendar" :fechasSeleccionadas="fechasSeleccionadas">
          </CalendarioFaenas>
        </div>

        <div class="lg:w-1/2 text-left pr-2">

          <div v-if="mostrarSpinner == true">
            <SpinnerLoading></SpinnerLoading>
          </div>
          <span class="text-white">{{ this.granularity  }}</span>
        </div>
      </div>
    </div>

    <div class="grid xs:grid-cols-1 sm:grid-cols-1 lg:grid-cols-1 p-3">
      <textarea id="adjustable-textarea" row="100" class="w-full  p-2 border border-gray-300 rounded
         text-xs focus:outline-none focus:ring-2 focus:ring-blue-500 text-blue  hidden " v-model="this.fs"></textarea>


      <GraficoMultiplesFaenasDiaO2NaturalOxigenado :isPortrait="isPortrait"
        :seriesMedicionesOxigenado="seriesO2Oxigenado" :seriesMedicionesNatural="seriesO2Natural"
        :glosaDataTypeOxigenado="glosaDataTypeOxigenado" :glosaDataTypeNatural="glosaDataTypeNatural"
        @loadMapa="loadMapa">
      </GraficoMultiplesFaenasDiaO2NaturalOxigenado>
      <textarea id="adjustable-textarea" class="w-full  p-2 border border-gray-300 rounded   text-xs
                focus:outline-none focus:ring-2 focus:ring-blue-500 text hidden" v-model="this.fs2"></textarea>
    </div>
    <div class="grid xs:grid-cols-1 sm:grid-cols-1 lg:grid-cols-1 p-3">
      <div v-if="mostrarSpinner == true">
        <SpinnerLoading></SpinnerLoading>
      </div>
      <!--  <GraficoMultiplesFaenasDiaOrp 
      @loadMapa="loadMapa" :seriesMediciones="seriesOrp" 
        nombreMedicion="ORP"
        tituloY="Ozonizado mV">
      </GraficoMultiplesFaenasDiaOrp> -->

      <GraficoMultiplesFaenasDiaOrpNaturalOzonizado :isPortrait="isPortrait"
        :seriesMedicionesOrpOzonizado="seriesOrpOzonizado" :seriesMedicionesOrpNatural="seriesOrpNatural"
        :glosaDataTypeOxigenado="glosaDataTypeOxigenado" :glosaDataTypeNatural="glosaDataTypeNatural"
        @loadMapa="loadMapa" />
    </div>

  </div>


</template>
<script>
import i18n from "@/i18n";

import CalendarioFaenas from "../calendar/CalendarioFaenas";

//import GraficoMultiplesFaenasDiaO2 from "./GraficoMultiplesFaenasDiaO2";
import GraficoMultiplesFaenasDiaO2NaturalOxigenado from "./GraficoMultiplesFaenasDiaO2NaturalOxigenado";
import GraficoMultiplesFaenasDiaOrpNaturalOzonizado from "./GraficoMultiplesFaenasDiaOrpNaturalOzonizado";
import ModalMapaFaenas from "./modal/ModalMapaFaenas";
import MenuAyudaResumen from "./modal/MenuAyudaResumen";
import ModalVisibilidad from "./modal/ModalVisibilidad";
import ModalInformes from "./modal/ModalInformes";
import PanelFaena from "./PanelFaena";
import { DateTime } from "luxon";

import axios from "axios";
import SpinnerLoading from "../SpinnerLoading";

import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';

export default {
  name: "FaenasCliente",
  props: ["idEmpresa", "isSmallScreen", "isPortrait"],
  emits: [
    "chgFaena",
    "chgFaenaCentros",
    "chgDivisionesMenuLat",
    "pantallasettings",
    "handleDropFaena"
  ],
  components: {
    CalendarioFaenas,

    //  GraficoMultiplesFaenasDiaO2,
    GraficoMultiplesFaenasDiaO2NaturalOxigenado,
    GraficoMultiplesFaenasDiaOrpNaturalOzonizado,
    ModalMapaFaenas,
    MenuAyudaResumen,

    ModalVisibilidad,
    ModalInformes,
    PanelFaena,
    SpinnerLoading,


  },
  mounted() {
    this.getPreferences();
    this.datos_mensuales = [60, 20, 10, 10, 0];
    // this.loadData();
    this.loadDataSesion();
    this.enviaDivisionesMenuLat();
    this.seriesO2Loaded = true;
    this.seriesLoaded = true;


    this.fechasSeleccionadas = this.restaDias(7)

    this.soloTest = []


    //  
  },
  data() {
    return {
      glosaDataTypeOxigenado: {
        glosa: "Oxigenado: Se encontraron datos simulados",
        faenas: []

      },
      glosaDataTypeNatural: {
        glosa: "Natural: Se encontraron datos simulados",
        faenas: []

      },

      fs: '',
      result_mediciones: false,
      isDragStart: false,
      fechasSeleccionadas: [],
      mostrarSpinner: false,
      showModalMapa: false,
      showModalAyuda: false,
      showModalVisibilidad: false,
      showModalInformes: false,
      showModalUsuarios: false,
      seriesLoaded: false,

      showPanelAyuda: false,
      datos_mensuales: [],
      faenas: [{}],
      cards: [{}],
      objFaenas: [{}],
      seriesFaenas: [],
      seriesFechas: [],
      contador_instancias: 0,
      faena: "",
      jaula: "",
      fechas: "",
      soloTest: [],
      nomMes: [
        "",
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],


      seriesOrp: [],
      seriesOxigeno: [],
      seriesO2Oxigenado: [],
      seriesO2Natural: [],
      idO2Disuelto: 5,
      idO2Saturado: 6,
      idOrp: 4,
      spinnerO2Disuelto: false,
      spinnerO2Saturado: false,
      idFaenaSeleccionada: 0,
      fs2: '',
      granularity: 'DAY'
    };
  },
  computed: {
    ...mapState('draggdrop', ['Draggables', 'Droppables'], 'auth', ['userLogin']),
    ...mapGetters('draggdrop', ['getDraggables', 'getDroppables'], 'auth', ['getUserPreferenceItems'])
  },
  methods: {

    ...mapActions("draggdropp", ["droppableAdd", "setIdCurrentDroppable", "setPosCurrentDroppable"], "divisiones", ["getDivisionesApi"]),
    ...mapMutations('draggdrop', ['draggableCreate', 'droppableCreate']),


    parseFechaChileCustom(str) {
      const dt = DateTime.fromFormat(str, 'dd HH:mm:ss MMM yyyy', {
        zone: 'America/Santiago',
        locale: 'en'
      });
      return dt.isValid ? dt.toMillis() : null;
    },

    loadModalInformes(valor) {
      console.log("modifica estado modal");
      this.showModalInformes = valor;
    },
    loadModalVisibilidad(valor) {
      console.log("modifica estado modal");
      this.showModalVisibilidad = valor;
    },
    loadModalAyuda(valor) {
      console.log("modifica estado modal");
      this.showModalAyuda = valor;
    },
    closeModalAyuda() {
      this.showModalAyuda = false;
    },
    closeModalVisibilidad() {
      this.showModalVisibilidad = false;
    },
    closeModalInformes() {
      this.showModalInformes = false;
    },
    loadAyuda(resp) {
      console.log("ayuda");
      this.showPanelAyuda = resp;
    },

    loadDataSesion() {
      this.faenas = this.$store.state.login.userLogin.info.faenas;
    },

    enviaDivisionesMenuLat() {
      this.$emit("chgDivisionesMenuLat", this.faenas);
    },
    loadMapa(id) {
      console.log("LOAD MAPA", id);
      this.showModalMapa = true;
      this.idFaenaSeleccionada = id;
    },
    closeModal() {
      this.showModalMapa = false;
    },
    loadDivisiones(f) {
      this.$emit("chgFaena", f);
    },
    loadCentros(f) {
      this.$emit("chgFaenaCentros", f);
    },
    loadHistorial(f) {
      this.$emit("chgHistorialCentros", f);
    },
    loadHomeSettings() {
      this.$emit("chgIdPantalla", { id: 0 });
    },
    getGranularity(fecha1, fecha2) {

      const dias = this.$store.getters.diferenciaDias(fecha1, fecha2);
      if (dias <= 7) {
        return 'HOUR';
      } else {
        return 'DAY';
      }
      /*
    const vista = 'historial';
    const minutos = this.diferenciaMinutos(fecha1, fecha2);  
    const granularity = this.$store.getters.calculaPuntosGranularidad( minutos, vista)
    return granularity;

*/
    },


    async getFecCalendar(f) {
      //  console.log('calendario', f);
      /*  este es el formato de f --> [ "01 10 2023",   "31 10 2023"]   */
      this.soloTest = []
      if (f[0] == "" || f[1] == "") return false;

      console.log("dates paso1:", f[0], f[1])

      const startDate = this.convertirFormatoFecha(f[0]); //2023-11-01
      const endDate = this.convertirFormatoFecha(f[1]);









      //console.log('agrega seriesFechas', this.seriesFechas);
      this.fechaConsulta = f;

      //this.arrayDias = this.seriesFechas
      this.glosaDataTypeNatural.faenas = [];
      this.glosaDataTypeOxigenado.faenas = [];


      this.spinnerO2Disuelto = true;
      this.mostrarSpinner = true;
      /*
      let natural = await this.getSeriesDia(startDate, endDate, this.idO2Disuelto, 'S');

      let oxigenado = await this.getSeriesDia(startDate, endDate, this.idO2Disuelto, 'N');
      this.seriesOxigeno = [[], natural, oxigenado]; // para botones opcion 1, opcion 2
      this.fs=JSON.stringify(oxigenado);
      let naturalOrp = await this.getSeriesDia(startDate, endDate, 4, 'S');
      let ozonizado = await this.getSeriesDia(startDate, endDate, 4, 'N');
      this.seriesOrp = [[], naturalOrp, ozonizado]; // para botones opcion 1, opcion 2
       */
      const vista = "resumen";
      const frecuencia_minutos = this.$store.getters.diferenciaMinutos(startDate, endDate);
      console.log('f1',frecuencia_minutos);
      this.granularity = this.$store.getters.calculaPuntosGranularidad(frecuencia_minutos, vista)


      this.seriesFechas = this.granularity == 'DAY' ? this.$store.getters.generaSerieFechas(startDate, endDate) : this.$store.getters.generaSerieHoras(startDate, endDate);


      Promise.allSettled([
        this.getSeriesDia(startDate, endDate, this.idO2Disuelto, 'S'),
        this.getSeriesDia(startDate, endDate, this.idO2Disuelto, 'N'),
        this.getSeriesDia(startDate, endDate, this.idOrp, 'S'),
        this.getSeriesDia(startDate, endDate, this.idOrp, 'N')
      ])
        .then(results => {

          const [natural, oxigenado, naturalOrp, ozonizado] = results.map(r => r.status === 'fulfilled' ? r.value : []);
          this.fs = JSON.stringify(natural);
          this.seriesOxigeno = [[], natural, oxigenado]; // para botones opción 1, opción 2
          this.seriesO2Oxigenado = oxigenado;
          this.seriesO2Natural = natural;

          this.seriesOrp = [[], naturalOrp, ozonizado]; // para botones opción 1, opción 2
          this.seriesOrpOzonizado = ozonizado;
          this.seriesOrpNatural = naturalOrp;
          this.mostrarSpinner = false;
        })
        .catch(error => {
          console.error('Error en promesas getSeriesDia:', error);
        });
    },


    async getSeriesDia(startDate, endDate, parametroBuscado, es_faena_natural) {

      const h = 0;
      const min = 0;
      const s = 0;

      let dataFaena = [];
      try {


        const apiKey = this.$store.state.login.tokenLogin;
        const objFaenas = this.$store.state.faenas;
        let arrayFaenas = [];
        arrayFaenas = objFaenas.faenas;

        for (let x = 0; x < arrayFaenas.length; x++) {
          // todas las jaulas de la Faena
          let objFaena = arrayFaenas[x];
          let jaulas = objFaena.unidades.filter(faena => faena.natural == es_faena_natural);
          const jaulaPromises = jaulas.map((jaula) => {
            if (jaula.id !== undefined) {
              const requestData = {
                idUnit: jaula.id,
                tsi: `${startDate} ${h}:${min}:${s}`,
                tsf: `${endDate} 23:59:59`,
                granularity: this.granularity,
              };
              return axios
                .post("/api/mon/getUnitData", requestData, {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `${apiKey}`,
                  },
                })
                .then((response) => {

                  let sensors = response.data.payload.sensors;
                  let arrayLecturas = []
                  sensors.forEach(sensor => {
                    sensor.params.forEach(param => {



                      if (param.id == parametroBuscado) {

                        if ("injectionType" in param && param.injectionType == 'dummy') {
                          if (es_faena_natural == 'S' && !this.glosaDataTypeNatural.faenas.includes(objFaena.nombre)) {
                            this.glosaDataTypeNatural.faenas.push(objFaena.nombre);
                          } else {
                            if (!this.glosaDataTypeOxigenado.faenas.includes(objFaena.nombre))
                              this.glosaDataTypeOxigenado.faenas.push(objFaena.nombre);
                          }
                        }




                        let updatedData = param.values;
                        updatedData.forEach(valor => {

                          let obj = {}
                          if (valor.value) {
                            // valor medicion y fecha medicion
                            obj = {
                              'jaulaId': jaula.id,
                              'value': valor.value,
                              'ts': valor.ts,
                              'injection': valor.injection
                            }

                            arrayLecturas.push({ ...obj });

                          }

                        });
                      }

                    });
                  });

                  return arrayLecturas

                })
                .catch((error) => {
                  console.log("error fetching unit data", error);
                  return [];
                });
            }

          });

          const arrayUnidades = await Promise.all(jaulaPromises);
          let dataFaenaDiario = [];
          /*
          1) recorrer arrayUnidades 
              [{
              jaulaId, value, ts
              },
              {
              jaulaId, value, ts
              },
              {
              jaulaId, value, ts
              }]
          2)  agregar a dataFaenaDiario[] objeto :
              { 
                'ts': (aaaa-mm-dd),  // campo de busqueda
                'acumulado': (valor medicion del dia + lo acumulado), 
                'jaulas_con_mediciones_ese_dia':  (cantidad incremental )
              }
          */
          arrayUnidades.forEach((mediciones) => {
            mediciones.forEach((medicion) => {

              let n = Math.floor(medicion.value * 100) / 100; // truncar sin rendondear
              const fec = medicion.ts;
              // const uni = medicion.jaulaId;
              const injection = medicion.injection;
              let dateSplit = ''


              if (this.granularity == 'DAY') {
                dateSplit = fec.split(" ")[0];

              } else {
                console.log('granularidad hora', fec);
                dateSplit = fec;
              }


              dateSplit = fec;

              if (dateSplit) {



                let index = dataFaenaDiario.findIndex(function (obj) {

                  return obj.ts == dateSplit;
                });



                if (index !== -1) {

                  //console.log('chk uni:', uni);
                  //console.log('chk (existe fecha ', dateSplit, ' en [])')

                  let cantidad_unidades = dataFaenaDiario[index].jaulas_con_mediciones_ese_dia;
                  cantidad_unidades++;

                  let acumulado = parseFloat(dataFaenaDiario[index].acumulado);
                  let totdia = parseFloat(n)

                  if (injection) {
                    dataFaenaDiario[index].injection = injection;
                  } else {
                    if (dataFaenaDiario[index].injection == '') {
                      dataFaenaDiario[index].injection = injection;
                    }
                  }


                  //console.log(uni, ': chk (valores acumulado en fecha', dateSplit, ':', acumulado)
                  //console.log(uni, ': chk (agrega en fecha', dateSplit, '):', totdia)




                  dataFaenaDiario[index].acumulado = acumulado + totdia;
                  dataFaenaDiario[index].jaulas_con_mediciones_ese_dia = cantidad_unidades;


                } else {


                  dataFaenaDiario.push({
                    'ts': dateSplit,
                    'acumulado': n,
                    'injection': injection,
                    'value': 0,
                    'jaulas_con_mediciones_ese_dia': 1
                  })

                }



              }

            });




          });
          // calcular aqui el promedio
          // recorrer array de objetos y promediar   
          dataFaenaDiario.forEach(function (datodiario) {
            let promedio = datodiario.acumulado / datodiario.jaulas_con_mediciones_ese_dia;

            datodiario.value = Math.floor(promedio * 100) / 100; // truncar sin rendondear

          });
          this.soloTest = dataFaenaDiario;
          let datosdiarios = [];

          if (arrayUnidades) {

            // generar una serie con todas las fechas seleccionadas
            // en el calendario, e insertar las mediciones de las fechas que
            // Sí registren datos en dataFaenaDiario

            // seriesFechas creado a partir del metodo  generaSerieFechas o generaSerieHoras
            for (let i = 0; i < this.seriesFechas.length; i++) {

              console.log('seriesFechas', this.seriesFechas[i])
              let result = dataFaenaDiario.find(item => item.ts === this.seriesFechas[i]);
              if (result) {

                let ts = this.convertirFormatoFechaDMA(result.ts);
                let med = result.value ? result.value : 0;
                // let fec = Date.parse(ts);
                let fec = Date.parse(this.parseCustomDate(ts))
                console.log('oscar', ts, fec);
                // console.log('dates',this.parseFechaChileCustom(fec));
                datosdiarios.push([fec, parseFloat(med), result.injection]);

              } else {

                let ts = this.convertirFormatoFechaDMA(this.seriesFechas[i]);
                let fec = Date.parse(this.parseCustomDate(ts))
                // let fec =this.parseCustomDate(ts)
                console.log('oscar', fec);
                // console.log('dates',this.parseFechaChileCustom(fec));
                datosdiarios.push([fec, 0, false]);
                this.mostrarSpinner = true;

              }


            }





          }
          let tipo = '';
          switch (parametroBuscado) {
            case this.idO2Disuelto:
              tipo = es_faena_natural == 'S' ? ` ${i18n.global.t('natural')}` : ` ${i18n.global.t('oxigenado')}`;
              break;
            case this.idOrp:
              tipo = es_faena_natural == 'S' ? ` ${i18n.global.t('natural')}` : ` ${i18n.global.t('ozonizado')}`;
              break;
          }

          let m = { name: objFaena.nombre + tipo, data: datosdiarios };

          dataFaena.push(m);
        } // itera faenas




        this.result_mediciones = true;



        return dataFaena;



      } catch (error) {
        console.log("error procesando faenas", error);
      }
    },

    parseCustomDate(str) {
      const [day, time, month, year] = str.split(' ');
      const months = {
        Jan: '01', Feb: '02', Mar: '03', Apr: '04',
        May: '05', Jun: '06', Jul: '07', Aug: '08',
        Sep: '09', Oct: '10', Nov: '11', Dec: '12'
      };
      const isoString = `${year}-${months[month]}-${day}T${time}`;
      return new Date(isoString);  //  2025-06-04T17:00:00.000Z
    },

    async getSeriesDia_2(startDate, endDate, parametroBuscado, es_faena_natural) {





      const h = 0;
      const min = 0;
      const s = 0;

      let dataFaena = [];
      try {


        const apiKey = this.$store.state.login.tokenLogin;
        const objFaenas = this.$store.state.faenas;
        let arrayFaenas = [];
        arrayFaenas = objFaenas.faenas;

        for (let x = 0; x < arrayFaenas.length; x++) {
          // todas las jaulas de la Faena
          let objFaena = arrayFaenas[x];
          let jaulas = objFaena.unidades.filter(faena => faena.natural == es_faena_natural);


          // Array de promesas para las solicitudes a axios
          // Si hay N elementos (jaulas) en el array jaulas, entonces se crearán N promesas en total,
          // una para cada elemento del array.
          //this.granularity = this.getGranularity(startDate, endDate);

          const jaulaPromises = jaulas.map((jaula) => {
            if (jaula.id !== undefined) {
              const requestData = {
                idUnit: jaula.id,
                tsi: `${startDate} ${h}:${min}:${s}`,
                tsf: `${endDate} 23:59:59`,
                granularity: this.granularity,
              };

              return axios
                .post("/api/mon/getUnitData", requestData, {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `${apiKey}`,
                  },
                })
                .then((response) => {

                  let sensors = response.data.payload.sensors;
                  let arrayLecturas = []
                  sensors.forEach(sensor => {
                    sensor.params.forEach(param => {
                      if (param.id == parametroBuscado) {
                        if ("injectionType" in param && param.injectionType == 'dummy') {
                          if (es_faena_natural == 'S' && !this.glosaDataTypeNatural.faenas.includes(objFaena.nombre)) {
                            this.glosaDataTypeNatural.faenas.push(objFaena.nombre);
                          } else {
                            if (!this.glosaDataTypeOxigenado.faenas.includes(objFaena.nombre))
                              this.glosaDataTypeOxigenado.faenas.push(objFaena.nombre);
                          }
                        }




                        let updatedData = param.values;
                        updatedData.forEach(valor => {

                          let obj = {}
                          if (valor.value) {
                            // valor medicion y fecha medicion
                            obj = {
                              'jaulaId': jaula.id,
                              'value': valor.value,
                              'ts': valor.ts,
                              'injection': valor.injection
                            }

                            arrayLecturas.push({ ...obj });

                          }

                        });
                      }

                    });
                  });

                  return arrayLecturas

                })
                .catch((error) => {
                  console.log("error fetching unit data", error);
                  return [];
                });
            }

          });

          const arrayUnidades = await Promise.all(jaulaPromises);
          let dataFaenaDiario = [];
          /*
          1) recorrer arrayUnidades 
              [{
              jaulaId, value, ts
              },
              {
              jaulaId, value, ts
              },
              {
              jaulaId, value, ts
              }]
          2)  agregar a dataFaenaDiario[] objeto :
              { 
                'ts': (aaaa-mm-dd),  // campo de busqueda
                'acumulado': (valor medicion del dia + lo acumulado), 
                'jaulas_con_mediciones_ese_dia':  (cantidad incremental )
              }
          */
          arrayUnidades.forEach((mediciones) => {
            mediciones.forEach((medicion) => {

              let n = Math.floor(medicion.value * 100) / 100; // truncar sin rendondear
              const fec = medicion.ts;
              // const uni = medicion.jaulaId;
              const injection = medicion.injection;
              let dateSplit = ''


              if (this.granularity == 'DAY') {
                dateSplit = fec.split(" ")[0];

              } else {
                console.log('granularidad hora', fec);
                dateSplit = fec;
              }


              dateSplit = fec;

              if (dateSplit) {



                let index = dataFaenaDiario.findIndex(function (obj) {

                  return obj.ts == dateSplit;
                });



                if (index !== -1) {

                  //console.log('chk uni:', uni);
                  //console.log('chk (existe fecha ', dateSplit, ' en [])')

                  let cantidad_unidades = dataFaenaDiario[index].jaulas_con_mediciones_ese_dia;
                  cantidad_unidades++;

                  let acumulado = parseFloat(dataFaenaDiario[index].acumulado);
                  let totdia = parseFloat(n)

                  if (injection) {
                    dataFaenaDiario[index].injection = injection;
                  } else {
                    if (dataFaenaDiario[index].injection == '') {
                      dataFaenaDiario[index].injection = injection;
                    }
                  }


                  //console.log(uni, ': chk (valores acumulado en fecha', dateSplit, ':', acumulado)
                  //console.log(uni, ': chk (agrega en fecha', dateSplit, '):', totdia)




                  dataFaenaDiario[index].acumulado = acumulado + totdia;
                  dataFaenaDiario[index].jaulas_con_mediciones_ese_dia = cantidad_unidades;


                } else {


                  dataFaenaDiario.push({
                    'ts': dateSplit,
                    'acumulado': n,
                    'injection': injection,
                    'value': 0,
                    'jaulas_con_mediciones_ese_dia': 1
                  })

                }



              }

            });




          });
          // calcular aqui el promedio
          // recorrer array de objetos y promediar   
          dataFaenaDiario.forEach(function (datodiario) {
            let promedio = datodiario.acumulado / datodiario.jaulas_con_mediciones_ese_dia;

            datodiario.value = Math.floor(promedio * 100) / 100; // truncar sin rendondear

          });
          this.soloTest = dataFaenaDiario;
          let datosdiarios = [];

          if (arrayUnidades) {

            // generar una serie con todas las fechas seleccionadas
            // en el calendario, e insertar las mediciones de las fechas que
            // Sí registren datos en dataFaenaDiario

            // seriesFechas creado a partir del metodo  generaSerieFechas o generaSerieHoras
            for (let i = 0; i < this.seriesFechas.length; i++) {

              console.log('seriesFechas', this.seriesFechas[i])
              let result = dataFaenaDiario.find(item => item.ts === this.seriesFechas[i]);
              if (result) {

                let ts = this.convertirFormatoFechaDMA(result.ts);
                let med = result.value ? result.value : 0;
                let fec = Date.parse(ts);
                console.log('oscar', fec);
                // console.log('dates',this.parseFechaChileCustom(fec));
                datosdiarios.push([fec, parseFloat(med), result.injection]);

              } else {

                let ts = this.convertirFormatoFechaDMA(this.seriesFechas[i]);
                let fec = Date.parse(ts)
                console.log('oscar', fec);
                // console.log('dates',this.parseFechaChileCustom(fec));
                datosdiarios.push([fec, 0, false]);
                this.mostrarSpinner = true;

              }


            }





          }
          let tipo = '';
          switch (parametroBuscado) {
            case this.idO2Disuelto:
              tipo = es_faena_natural == 'S' ? ' Natural' : ' Oxigenado';
              break;
            case this.idOrp:
              tipo = es_faena_natural == 'S' ? ' Natural' : ' Ozonizado';
              break;
          }

          let m = { name: objFaena.nombre + tipo, data: datosdiarios };

          dataFaena.push(m);
        } // itera faenas




        this.result_mediciones = true;



        return dataFaena;



      } catch (error) {
        console.log("error procesando faenas", error);
      }
    },






    processSensorData(sensors, parametroId, jaulaId, faenaNombre, tipoFaena) {
      const resultados = [];
      for (const sensor of sensors) {
        for (const param of sensor.params) {
          if (param.id !== parametroId) continue;

          if (param.injectionType === 'dummy') {
            const target = tipoFaena === 'S' ? this.glosaDataTypeNatural : this.glosaDataTypeOxigenado;
            if (!target.faenas.includes(faenaNombre)) {
              target.faenas.push(faenaNombre);
            }
          }

          for (const valor of param.values) {
            if (!valor.value) continue;
            resultados.push({
              jaulaId,
              value: valor.value,
              ts: valor.ts,
              injection: valor.injection || false
            });
          }
        }
      }
      return resultados;
    },

    aggregateReadings(readings, granularity) {
      const agregados = [];

      for (const m of readings) {
        const key = granularity === 'DAY' ? m.ts.split(" ")[0] : m.ts;
        const idx = agregados.findIndex(d => d.ts === key);

        if (idx >= 0) {
          const obj = agregados[idx];
          obj.acumulado += m.value;
          obj.jaulas_con_mediciones_ese_dia++;
          if (m.injection && !obj.injection) obj.injection = true;
        } else {
          agregados.push({
            ts: key,
            acumulado: m.value,
            jaulas_con_mediciones_ese_dia: 1,
            injection: m.injection || false,
            value: 0
          });
        }
      }

      for (const d of agregados) {
        d.value = Math.floor((d.acumulado / d.jaulas_con_mediciones_ese_dia) * 100) / 100;
      }

      return agregados;
    },


    async getPreferences() {
      // iterar FAENAS, si el valor de FAENAS[n].id existe  en PREFERENCIAS[n].id, agregar 
      // en FAENAS[n] el atributo order, con el valor de PREFERENCIAS[n].order

      let objFaenas = this.$store.getters.getFaenas;
      let jsonPref = this.$store.getters.getUserPreferenceItems;
      let objPreferencias = jsonPref;

      const parsedPreferencias = objPreferencias.map(pref => ({
        ...pref,
        id: parseInt(pref.id, 10)
      }));
      objFaenas.forEach(faena => {
        const pref = parsedPreferencias.find(p => p.id === faena.id);
        if (pref) {
          faena.order = pref.order;
          faena.visible = pref.visible;

        }
      });
      objFaenas.sort((a, b) => a.order - b.order);
      await this.$store.dispatch('setFaenas', objFaenas);
      await this.$store.dispatch('droppableCreate', objFaenas);
    },




    convertirFormatoFecha(fechaOriginal) {
      if (!fechaOriginal) return null;
      const [dia, mes, año] = fechaOriginal.split(" ");
      return (dia && mes && año) ? `${año}-${mes}-${dia}` : null;

    },

    convertirFormatoFechaDMA(fechaOriginal) {
      try {
        const partes = fechaOriginal.split("-");

        if (partes.length === 3) {
          const dia = partes[0];
          let paso = parseInt(partes[1])
          const mes = this.nomMes[Number(paso)];
          const año = partes[2];
          const nuevaFecha = `${año} ${mes} ${dia}`;


          return nuevaFecha;
        }
      } catch (error) {
        console.log(error);
      }
      return null;
    },


    getRnd(min, max) {
      let flot = Math.random() * (max - min + 1) + min;

      return flot.toFixed(2);
    },
    showModalHelp() {
      console.log("show modal");
      this.showModal = true;
    },
    handleDragOVer(event) {
      console.log("over");
      event.preventDefault();
    },
    handleDragEnter(event) {
      console.log("enter", event);
    },
    handleDrop() {
      console.log("DROP");
      this.$store.dispatch("droppableAdd");
      this.isDragStart = false;
    },
    handleDropFaena(id) {
      console.log("DROP en Faena", id);
      this.$store.dispatch("setPosCurrentDroppable", id);
      this.$emit("handleDropFaena");
    },
    handleVisibilidad() {
      this.$emit("handleDropFaena");
    },
    handleDragFaena(id) {
      console.log("tomando faena ", id);
      this.$store.dispatch("setIdCurrentDroppable", id);
      this.isDragStart = true;
    },
    handleDragOver(event) {
      event.preventDefault();
    },
    restaDias(minus) {

      let hoy = this.$store.getters.fechaHoraActual();

      let diaHoy = String(hoy.getDate).padStart(2, '0');
      let mesHoy = String(hoy.getMonth).padStart(2, '0');
      let añoHoy = String(hoy.getFullYear).padStart(2, '0');
      let fechaHoy = `${diaHoy} ${mesHoy} ${añoHoy}`;

      let fec = this.$store.getters.restarDias(diaHoy, mesHoy, añoHoy, minus);
      let dd = String(fec.getDate).padStart(2, '0');
      let mm = String(fec.getMonth).padStart(2, '0');
      let aa = String(fec.getFullYear).padStart(2, '0');
      let fechaRestada = `${dd} ${mm} ${aa}`;


      return [fechaRestada, fechaHoy]
    },



  },



};
</script>